export function upload({ payload }) {
  let data = new FormData()

  for (let key in payload) {
    data.append(`user_documents[${key}][file][file]`, payload[key])
  }

  return {
    url: `/api/users/me/documents`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
    body: data,
  }
}

export function validate() {
  return {
    url: `/api/users/request_account_validation`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}
